import { AbstractControl, ValidationErrors } from '@angular/forms';
import {
  getYear, isValid, parse, parseISO
} from 'date-fns';

export class BirthdayValidator {
  static validate(control: AbstractControl): ValidationErrors | null {
    if (control.value === null || control.value === undefined) return null;

    const value = String(control.value);
    if (value.trim().length === 0) return null;

    let parsedDate = parseISO(value);

    // If ISO parsing fails, try parsing 'MM/dd/yyyy' format
    if (!isValid(parsedDate)) {
      // Provide a reference date (new Date()) for parse function
      parsedDate = parse(value, 'MM/dd/yyyy', new Date());
    }

    if (!isValid(parsedDate)) {
      return { dateError: 'Please enter a valid date in the format shown' };
    }

    const today = new Date();
    if (parsedDate > today) {
      return { dateError: 'Birth date cannot be in the future' };
    }

    const currentYear = getYear(today);
    const earliestYear = currentYear - 120;
    const clientBirthdayYear = getYear(parsedDate);

    if (clientBirthdayYear < earliestYear) {
      return { dateError: `Birth year must be between ${earliestYear} and ${currentYear}` };
    }

    return null;
  }
}
